import React from 'react';
import ReactDOM from 'react-dom';
import './antd.css';

import './index.css';
import App from './App';
import ContextProvider from './context';

import "./_conf.scss";




ReactDOM.render(
  <React.StrictMode>
    <ContextProvider>        
        <App />
    </ContextProvider>     
  </React.StrictMode>,
  document.getElementById('root')
);

